/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-course-unit-info-learning-materials',
    templateUrl: './course-unit-info-learning-materials.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CourseUnitInfoLearningMaterialsComponent {
    @Input() learningMaterial: any;
    @Input() literature: any;
}
